// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"LoadingSpin--next-sr-only--1_mqu6o","loadingWrapper":"LoadingSpin--loadingWrapper--3Lx4PCd","loadingSpin":"LoadingSpin--loadingSpin--1d2m68k"};